export interface FileData {
  name: string;
  base64Data: string;
  mimeType: string;
  size: number;
}
export const convertFileToBase64 = async (file: File): Promise<FileData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve({
        name: file.name,
        base64Data: reader.result as string,
        mimeType: file.type,
        size: file.size,
      });
    reader.onerror = (error) => reject(error);
  });
};

export const resizeBase64ImageToBase64 = async (
  base64: FileData,
  maxSize = 1000,
): Promise<FileData> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      let { width, height } = img;

      // Calculate new dimensions if necessary
      if (width > maxSize || height > maxSize) {
        const ratio = Math.min(maxSize / width, maxSize / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      if (!ctx) return reject(new Error("Canvas context not available"));

      ctx.drawImage(img, 0, 0, width, height);

      const resizedBase64 = canvas.toDataURL("image/png"); // You can change format here
      resolve({
        name: base64.name,
        base64Data: resizedBase64,
        mimeType: base64.mimeType,
        size: base64.size,
      });
    };

    img.onerror = () => reject(new Error("Image loading failed"));
    img.src = base64.base64Data;
  });
};
